import { cupSizes, bandSizes } from './sizes';
import rules from './validationRules';

export const calculateBraSize = (measuredResults) => {
	const calculatedCups = calculateCups(measuredResults);

	const { bandSize } = measuredResults;

	const calculatedBandSize = findBandSize(bandSize);
	const regularSize = findRegularSize(
		calculatedCups.cup,
		calculatedBandSize.band
	);

	return {
		...calculatedCups,
		bandSize: calculatedBandSize.band,
		regularSize
	};
};

const findRegularSize = (biggerCup, bandSize) => {
	const cupSize = cupSizes.find((cupSize) => cupSize.cup === biggerCup);
	const regularSize = cupSize.regularSize.find((size) => {
		const h = size.substring(0, 2) === bandSize.toString();
		return h;
	});

	return regularSize != null ? regularSize : '100X';
};

const calculateCups = (measuredResults) => {
	const { leftBreast, rightBreast } = measuredResults;

	if (leftBreast > rightBreast) {
		const biggerCupSize = findCupSize(leftBreast);
		const smallerCupSize = findCupSize(rightBreast);

		const { cup } = biggerCupSize;

		const difference = findDifference(
			biggerCupSize.cup,
			smallerCupSize.cup
		);

		return {
			paddingCup: `R${difference}`,
			tooAsym: difference === 100,
			cup
		};
	} else {
		const biggerCupSize = findCupSize(rightBreast);

		const smallerCupSize = findCupSize(leftBreast);
		const { cup } = biggerCupSize;

		const difference = findDifference(
			smallerCupSize.cup,
			biggerCupSize.cup
		);

		return {
			paddingCup: `L${difference}`,
			tooAsym: difference === 100,
			cup
		};
	}
};

const findBandSize = (value) => {

	let foundBand = bandSizes.find((size) => {
		const cmRange = range(size.cm[0], size.cm[1]);

		return cmRange.includes(parseInt(value, 10));
	});

	if(foundBand != null){
		return foundBand;
	}

	console.log('Not possible to calculate band size');

	return {
		band: value
	};


	// try {
	// 	return bandSizes.find((size) => {
	// 		const cmRange = range(size.cm[0], size.cm[1]);

	// 		return cmRange.includes(parseInt(value, 10));
	// 	});
	// } catch (e) {
	// 	return {};
	// }
};

export const range = (start, end) => {
	return Array(end - start + 1)
		.fill()
		.map((_, idx) => start + idx);
};

const findCupSize = (value) => {

	let foundSize = cupSizes.find((size) => size.cm.includes(parseInt(value, 10)));
	if(foundSize != null){
		return foundSize;
	}
	console.log('Not possible to calculate cup size');

	return {
		cup: 100,
		regularSize: ['100X']
	}

	// try {
	// 	return cupSizes.find((size) => size.cm.includes(parseInt(value, 10)));
	// } catch (e) {
	// 	console.log('Not possible to calculate cup size');
	// 	return {};
	// }
};

const findDifference = (left, right) => {
	const dif = Math.abs(left - right);
	// 1 cup difference
	if (dif === 5) {
		return 2;
	}
	// 2 cups difference
	if (dif === 10) {
		return 3;
	}

	// same cup cups difference
	if (dif === 0) {
		return 0;
	}

	if (dif > 10) {
		return 100;
	}
	return;
};
